import React from 'react'
import dayjs from 'dayjs'

export default ({ date, format, component, ...rest }) => {
  const Component = component || 'span'
  const dateString = dayjs(date).format(format || 'D. MMMM YYYY')
  return <Component {...rest}>{dateString}</Component>
}
